import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Stack, CircularProgress, TextField, Typography, Card, Breakpoint, CardContent} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { actionCreators, selectors } from "../../store";
import { CONTENT_COLOR } from "../../models/Constants";
import { Message } from "../../models/Index";

//#region Props
export type EndScreenProps = 
    ReturnType<typeof mapStateToProps> 
    & ReturnType<typeof mapDispatchToProps>
//#endregion

export const EndScreen = (props: EndScreenProps) => {
    //#region Fields
    const {
        userId,
        userName,
        isAuthorize
    } = props;

    const {
       onShowMessage,
    } = props;

    const [loadingFlag, setLoadingFlag] = useState(false);

    const navigate = useNavigate()

    useEffect(() => {
        const handleBeforeUnload = (event:any) => {
            event.preventDefault()
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [navigate]);

    useEffect(() => {
        const handlePopState = (event:any) => {
          event.preventDefault();
          window.history.pushState(null, document.title, window.location.href);
        };
    
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', handlePopState);
    
        return () => {
          window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    useEffect(() => {
        if(!isAuthorize)
        {
            navigate('/login')
        }
    }, [isAuthorize])

    return (
        <>
        <div style={{display:"flex", minHeight:"100vh", flexDirection:"column"}}>
            {loadingFlag && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <Stack style={{ height: '100vh', background: '#F9FAFB'}} justifyContent={'flex-start'}>
                <Stack justifyContent="center" alignItems="center" mt={2}>
                    <Card sx={{ width: 400, boxShadow: 5, marginTop: 3, marginBottom: 3 }}>
                        <CardContent>
                            <Typography sx={{color:CONTENT_COLOR, fontSize:30, fontWeight:"bold"}}>ストレス耐性テスト</Typography>
                            <Stack direction={"row"} sx={{alignItems:"center"}} spacing={1} marginTop={2} marginLeft={"5px"}>
                                <TextField  
                                    defaultValue={userName}
                                    sx={{
                                        '& .MuiInputBase-input': {
                                        height: '8px',
                                        textAlign:"center",
                                        },
                                        width:"50%",
                                        fontSize:16,
                                    }}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                ></TextField>
                                <Typography fontSize={16}>様</Typography>
                            </Stack>
                            <Stack direction={"column"} mt={3} mb={6} marginInline={"10px"} spacing={3}>
                                <Typography fontSize={20}>
                                ストレス耐性テストはこれにて終了となります。
                                </Typography>
                                <Typography fontSize={20}>
                                お疲れ様でした。
                                </Typography>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </Stack>
        </div>  
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        userId: state.app.user?.userId,
        userName: state.app.user?.userName,
        isAuthorize: selectors.isAuthorize(state),
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        onShowMessage: (message: Message) => dispatch(actionCreators.showMessage(message)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(EndScreen);
